import { useTranslation } from 'react-i18next'

import { ArrowUDownLeftIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ProductsToReturn = ({ productsCount }) => {
  const { t } = useTranslation()

  if (!productsCount) return null

  return (
    <Styles.Container>
      <ArrowUDownLeftIcon size={24} />
      <Text type="bodyMRegular">
        {productsCount} {productsCount === 1 ? t('Producto') : t('Productos')} {t('a devolver')}
      </Text>
    </Styles.Container>
  )
}

export default ProductsToReturn
